@let c = charter();
<div class="kpis">
  @if (currentAct(); as act) {
    <span class="kpi kpi--lead" [title]="baseLabel() ? 'Aplicada sobre ' + baseLabel() : ''">
      <i class="pi pi-verified kpi__icon kpi__icon--ok" aria-hidden="true"></i>
      Vigente: <b>{{ act.label }}</b>
      @if (actDate(); as date) {
        <span class="kpi__muted">· {{ date | vaultDate }}</span>
      }
    </span>
  }
  @if (nature(); as n) {
    <span class="kpi"><i class="pi pi-building kpi__icon" aria-hidden="true"></i>{{ n }}</span>
  }
  @if (capital(); as cap) {
    <span class="kpi">
      <i class="pi pi-wallet kpi__icon" aria-hidden="true"></i>
      Capital <b>{{ cap }}</b>
    </span>
  }
  <span class="kpi">
    <i class="pi pi-users kpi__icon" aria-hidden="true"></i>
    @if (holders().count !== null) {
      <b>{{ holders().count }}</b>
    }
    {{ holders().text }}
  </span>
  @if (administration(); as adm) {
    <span class="kpi"><i class="pi pi-sitemap kpi__icon" aria-hidden="true"></i>{{ adm }}</span>
  }
  @if (processingCount() > 0) {
    <span class="kpi kpi--pending">
      <span class="kpi__dot" aria-hidden="true"></span>
      O Cog está lendo <b>{{ processingCount() }}</b>
      {{ processingCount() === 1 ? 'documento' : 'documentos' }}
    </span>
  }
  @if (missing().length > 0) {
    <span class="kpi kpi--pending" [title]="'Faltam: ' + missing().join(', ')">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      Faltam <b>{{ missing().length }}</b> {{ missing().length === 1 ? 'ato' : 'atos' }}
    </span>
  }
  @if (review(); as r) {
    <button type="button" class="review" (click)="reviewRequested.emit()">
      <span class="kpi__dot" aria-hidden="true"></span>
      {{ r }}
      <i class="pi pi-arrow-right" aria-hidden="true"></i>
    </button>
  } @else if (c.status === 'current') {
    <span class="kpi kpi--ok">
      <i class="pi pi-check-circle" aria-hidden="true"></i> Atos conferidos
    </span>
  }
</div>
